module.exports = __webpack_public_path__ + "img/stopwatch.9f4e73ec.svg";